
import { defineComponent } from "vue";
import { Carousel, Slide, Navigation } from "vue3-carousel";

export default defineComponent({
  name: "BestServices",
  components: {
    Carousel,
    Slide,
    Navigation,
  },
  data: () => ({
    settings: {
      itemsToShow: 1,
      snapAlign: "center",
    },
    services: [
      {
        id: 1,
        datadelay: "200",
        image: require("../../assets/images/team/member-1.jpg"),
        name: "Dr. Eduard Cocea",
        designation: "Medic primar psihiatru",
        // badge: "Fondator",
        url: '/echipa_medicala/eduard_cocea#echipa_medicala'
      },
      {
        id: 2,
        datadelay: "300",
        image: require("../../assets/images/team/member-2.jpg"),
        name: "Dr. Xenia Cocea",
        designation: "Medic rezident psihiatru",
        // badge: "Co-fondator",
        url: '/echipa_medicala/xenia_cocea#echipa_medicala'
      },
      {
        id: 3,
        datadelay: "400",
        image: require("../../assets/images/team/member-3.jpg"),
        name: "Dr. Raluca Roman",
        designation: "Medic specialist neurolog",
        url: '/echipa_medicala/raluca_roman#echipa_medicala'
      },
      {
        id: 4,
        datadelay: "500",
        image: require("../../assets/images/team/member-4.jpg"),
        name: "Dr. Gina Neculăeş",
        designation: "Medic specialist endocrinolog",
        url: '/echipa_medicala/gina_neculaes#echipa_medicala'
      },
      {
        id: 5,
        datadelay: "500",
        image: require("../../assets/images/team/member-6.jpg"),
        name: "Dr. Claudiu Nicolaiev",
        designation: "Medic specialist în Diabet, Nutriție...",
        url: '/echipa_medicala/claudiu_nicolaiev#echipa_medicala'
      },
      {
        id: 6,
        datadelay: "500",
        image: require("../../assets/images/team/member-7.jpg"),
        name: "Dr. Petronela Pascaru",
        designation: "Medic specialist psihiatru",
        url: '/echipa_medicala/petronela_pascaru#echipa_medicala'
      },
      {
        id: 8,
        datadelay: "500",
        image: require("../../assets/images/team/member-8.jpg"),
        name: "Dr. Alexandra Menghereș",
        designation: "Medic specialist reumatolog",
        url: '/echipa_medicala/alexandra_veronica_mengheres#echipa_medicala'
      },
      {
        id: 9,
        datadelay: "500",
        image: require("../../assets/images/team/member-9.jpg"),
        name: "Dr. Alexandra Năstasă",
        designation: "Medic specialist cardiolog",
        url: '/echipa_medicala/alexandra_ioana_nastasa#echipa_medicala'
      },
    ],
    breakpoints: {
      0: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      768: {
        itemsToShow: 2,
        snapAlign: "start",
      },
      1200: {
        itemsToShow: 3,
        snapAlign: "center",
      },
      1400: {
        itemsToShow: 4,
        snapAlign: "start",
      },
    },
  }),
});
